import { Splide } from "@splidejs/splide";

class Slider {

  constructor(selector) {

    this.sliders = document.querySelectorAll(selector);

    this.sliders.forEach(slider => {

      let slides = slider.querySelectorAll('.splide__slide');

      if(slides.length > 1) {

        slider.splide = new Splide(slider, {
          type: 'loop',
          pagination: false,
          arrows: true,
          updateOnMove: true,
          speed: 1000,
          gap: 0,
          slideFocus: false,
        });

        slider.splide.mount();

      }

    });

  }

}

export default Slider;